/* global TimelineMax TweenMax Quad */
import React from 'react';
import Frame from '../../views/Frame.jsx';
import Extras from '../../../data/extras.json';

import createSprite from '../../../lib/createSprite';
import spritesHelper from '../../../lib/spritesHelper';
import Utils from '../../../lib/utils';

import CommonAnimations from '../../../animations/common';
import PumpersAnimations from '../../../animations/pumpers';
import GuillotineAnimations from '../../../animations/guillotine';

import Audio from '../../../lib/audio';

import { isPhone } from '../../../lib/isMobile';

const Pumper = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        texts: React.PropTypes.texts,
        focus: React.PropTypes.bool,

        onBuilt: React.PropTypes.func,

        title: React.PropTypes.string,
        role: React.PropTypes.string,
        hasGuillotine: React.PropTypes.bool,
    },

    contextTypes: {
        debug: React.PropTypes.bool,
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        cleanTint: React.PropTypes.number,
        intensitiesColors: React.PropTypes.object,
        language: React.PropTypes.string,
    },

    timeline: null,
    mainTimeline: null,
    movieclipTimelines: [],
    guillotineTimeline: null,
    sprites: null,
    pixiFlux: null,
    particlesEmitter: null,
    elapsedTime: null,
    audios: null,
    particlesContainer: null,

    getDefaultProps: function () {
        return {
            texts: [
                {
                    title: 'sophia_jamal',
                    subtitle: 'sophia_jamal_title',
                    opts: {
                        x: 50,
                        y: 215,
                        croppedY: 280,
                    },
                },
            ],
            movieclipKeys: [],
            pumperKey: null,
            pumpKey: null,
            className: 'pumper',
            particlesLifetime: {
                min: 1.4,
                max: 1.5,
            },
            particlesAcceleration: {
                x: 0,
                y: 2400,
            },
            nextFrameMaskGradientStart: 0.2,
            nextFrameMaskGradientEnd: 0.4,
            audioUrls: {
                flux: ['/audio/28nov/general-liquide-mouv-01.ogg', '/audio/28nov/general-liquide-mouv-01.mp3'],
            },
            // The keys for the extra texts
            title: 'tom',
            role: 'tom_title',
            hasGuillotine: false,
        }
    },

    render: function () {
        const texts = _.merge(this.props.texts, [
            {
                title: Extras[this.props.title].text[this.context.language],
                subtitle: Extras[this.props.role].text[this.context.language],
            },
        ]);

        return (
            <Frame
                {...this.props}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                onTick={this.onTick}
                texts={texts}
            />
        );
    },

    build: function(container, timeline, opts, fullContainer) {
        // console.log('fc', fullContainer.name);
        this.sprites = {
            container,
            fullContainer,
        };
        this.timeline = timeline;
        this.mainTimeline = new TimelineMax({
            paused: true,
        });
        this.pixiFlux = opts.pixiFlux;

        this.buildObjects();
        this.buildParticles();
        this.animateObjects();

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: key === 'flux'
            });
        }, this));

        if (this.props.onBuilt)
        {
            this.props.onBuilt(container, timeline, opts);
        }
    },

    play: function() {
        if (this.audios.flux) {
            this.audios.flux.fadeInFast();
        }

        if (this.particlesContainer !== null) {
            TweenMax.to(this.particlesContainer, 1, {
                alpha: 1,
            });
        }
    },

    pause: function() {
        if (this.audios.flux) {
            this.audios.flux.fadeOutFast();
        }
        if (this.particlesContainer !== null) {
            TweenMax.to(this.particlesContainer, 1, {
                alpha: 0,
            });
        }
    },

    destroy: function() {

        if (this.guillotineTimeline !== null){
            TweenMax.killTweensOf(this.guillotineTimeline);
            this.guillotineTimeline.removeCallback();
            this.guillotineTimeline.kill();
            this.guillotineTimeline = null;
            // console.log('kill gui');
        }

        if (this.mainTimeline !== null){
            this.mainTimeline.removeCallback();
            this.mainTimeline.kill();
            this.mainTimeline = null;
        }

        if (this.movieclipTimelines.length > 0) {
            this.movieclipTimelines.forEach((timeline) => {
                timeline.removeCallback();
                timeline.kill();
            });
            this.movieclipTimelines = [];
        }

        if (this.particlesEmitter !== null) {
            this.particlesEmitter.destroy();
            this.particlesEmitter = null;
        }

        if (this.audios.flux) {
            this.audios.flux.destroy();
            this.audios.flux = null;
        }

        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }

        this.sprites = null;
        this.audios = null;
        this.movieclipTimelines = null;
    },

    buildObjects: function() {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;
        var objs = props.objs;
        var container = sprites.container;
        var fullContainer = sprites.fullContainer;

        var i, j, jl, movieclipProp, movieclipObject, movieclip;

        // pumpClips - intensity-related movieclip
        for (i = minIntensity; i <= maxIntensity; i++)
        {
            for (j = 0, jl = props.movieclipKeys.length; j < jl; j++)
            {
                movieclipProp = props.movieclipKeys[j]+i;
                movieclipObject = objs[movieclipProp];
                movieclip = sprites[movieclipProp] = createSprite(movieclipObject);
                movieclip.userData = {character: true};
                Utils.setSizeAndPositionFromRefSize(movieclip, props.width, props.height, movieclipObject);
                container.addChild(movieclip);
            }
        }

        // pump
        var pumpObject = _.get(objs, props.pumpKey, null);
        if (pumpObject)
        {
            var pump = createSprite(pumpObject);
            Utils.setSizeAndPositionFromRefSize(pump, props.width, props.height, pumpObject);
            container.addChild(pump);
        }

        // flux
        var fluxContainer = sprites.flux = new PIXI.Container();
        var fluxMask = spritesHelper.createFrameMaskFromSize(props.width, props.height * 0.86);
        fluxContainer.mask = fluxMask;
        fluxContainer.name = 'flux';
        if (this.pixiFlux)
        {
            this.pixiFlux.setContainer(fluxContainer, props.width);
        }

        // particles
        var particlesContainer = sprites.particles = new PIXI.Container();
        particlesContainer.name = 'particles';
        this.particlesContainer = particlesContainer;

        // particles mask
        var canvasParticlesMask = document.createElement('canvas');
        canvasParticlesMask.width = (props.width + props.border) * 2;
        canvasParticlesMask.height = props.height;
        var canvasContext = canvasParticlesMask.getContext('2d');
        var nextFrameGradient = canvasContext.createLinearGradient(0, props.height, 0, 0);
        nextFrameGradient.addColorStop(0, 'black');
        nextFrameGradient.addColorStop(props.nextFrameMaskGradientStart, 'black');
        nextFrameGradient.addColorStop(props.nextFrameMaskGradientEnd, 'white');
        canvasContext.fillStyle = 'white';
        canvasContext.fillRect(0, 0, props.width + props.border, props.height);
        canvasContext.fillStyle = nextFrameGradient;
        canvasContext.fillRect(props.width + props.border, 0, props.width, props.height);

        var particlesMaskTexture = new PIXI.Texture.fromCanvas(canvasParticlesMask);
        var particlesMask = new PIXI.Sprite(particlesMaskTexture);
        particlesContainer.mask = particlesMask;

        container.addChild(fluxMask);
        container.addChild(particlesContainer);
        container.addChild(fluxContainer);
        container.addChild(particlesMask);

        // Guillotine
        if (props.hasGuillotine === true) {
            const background = new PIXI.Container();
            background.x = 0;
            background.y = 0;

            const phone = isPhone();

            const graph = new PIXI.Graphics();
            graph.x = 0;
            graph.y = 0;
            graph.width = props.width;
            graph.height = props.height;
            background.addChild(graph);

            // wheel left
            const wheelObj = objs.wheel;
            sprites.wheelLeft = createSprite(wheelObj);
            const wheelLeft = sprites.wheelLeft;
            wheelLeft.scale.x = 0.7;
            wheelLeft.scale.y = 0.7;

            wheelLeft.x = (props.width / 2) + Math.floor(wheelLeft.width * 0.5);
            wheelLeft.y = props.height * 0.05;

            // guillotine
            const guillotineObj = objs.guillotine;
            sprites.guillotine = createSprite(guillotineObj);
            const guillotine = sprites.guillotine;
            guillotine.scale.x = phone ? 0.55 : 0.7;
            guillotine.scale.y = phone ? 0.55 : 0.7;
            guillotine.x = (props.width / 2) - Math.floor(guillotine.width * 0.5);
            guillotine.y = props.height * 0.12;

            // rope left
            const ropeObj = objs.rope;
            sprites.ropeLeft = createSprite(ropeObj);
            const ropeLeft = sprites.ropeLeft;
            ropeLeft.scale.x = 0.7;
            ropeLeft.scale.y = 0.7;
            ropeLeft.height = ropeLeft.height * (phone ? 1.1 : 1.6);
            ropeLeft.x = (props.width / 2) + Math.floor(wheelLeft.width * 0.07);
            ropeLeft.y = props.height * 0.05;

            background.addChild(ropeLeft);
            background.addChild(guillotine);
            background.addChild(wheelLeft);

            container.addChild(background);
        }
    },

    buildParticles: function()
    {
        this.elapsedTime = Date.now();
        var color = this.context.cleanTint.toString(16);
        var emitter = this.particlesEmitter = PumpersAnimations.createParticlesEmitter(this.sprites.particles, this.props.objs.blob.texture, {
            color: {
                start: color,
                end: color
            },
            acceleration: {
                x: this.props.particlesAcceleration.x,
                y: this.props.particlesAcceleration.y * this.props.height / 906
            },
            lifetime: this.props.particlesLifetime
        });
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var timeline = this.timeline;

        // intensities-influenced movieclips
        this.movieclipTimelines = [];
        var i, movieclipProp, movieclip, movieclipObject, intensityMovieclips;
        props.movieclipKeys.map(_.bind(function(intensityMovieclipKey, intensityMovieclipIndex){
            var intensityMovieclips = [];
            for (i = context.minIntensity; i <= context.maxIntensity; i++)
            {
                movieclipProp = intensityMovieclipKey+i;
                movieclip = sprites[movieclipProp];
                movieclipObject = objects[movieclipProp];
                movieclip.name = intensityMovieclipKey+i;
                intensityMovieclips.push(movieclip);
            }
            this.movieclipTimelines.push(timeline.add(CommonAnimations.getMovieclipTimeline(intensityMovieclips, {
                fps: 4,
                onFrameUpdate: this.onFrameUpdate
            }), intensityMovieclipIndex * 0.1));
        }, this));

        // guillotine
        // const { container } = this.state;
        if (props.hasGuillotine === true) {
            const container = sprites.container;
            const wheelLeft = sprites.wheelLeft;
            const guillotine = sprites.guillotine;
            const ropeLeft = sprites.ropeLeft;
            const ropePixels = container.height * 0.05;

            this.guillotineTimeline = GuillotineAnimations.getGuillotineTimeline({
                leftElements: [guillotine],
                // topElements: ropeTop,
                rightElements: null,
                wheels: wheelLeft,
                pixels: ropePixels,
                rotation: -15,
            });

            this.mainTimeline.add(this.guillotineTimeline);
            this.mainTimeline.pause();
            this.mainTimeline.play(); // devrait être callé par le play, après le build... hmm
        }

        if (this.props.onAnimationReady) {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity: intensity;

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline){
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        // intensity-influenced movieclips
        props.movieclipKeys.map(_.bind(function(intensityMovieclipKey, intensityMovieclipIndex)
        {
            for (var i = minIntensity; i <= maxIntensity; i++)
            {
                var movieclip = sprites[intensityMovieclipKey+i];
                movieclip.visible = i === intensity;
            }
        }, this));

        this.particlesEmitter.emit = false;
        var color = context.intensitiesColors[intensity] || context.intensitiesColors[3];
        this.particlesEmitter.startColor = [
            (color & 0xff0000) >> 16,
            (color & 0x00ff00) >> 8,
            (color & 0x0000ff)
        ];

        if (this.guillotineTimeline !== null) {
            this.guillotineTimeline.pause();
            const timeline = new TimelineMax();
            const progress = ((intensity - minIntensity) * 0.8) / (maxIntensity - minIntensity);

            TweenMax.killTweensOf(this.guillotineTimeline);

            timeline.to(this.guillotineTimeline, 2, {
                progress,
                ease: Quad.easeOut,
            });
            timeline.to(this.guillotineTimeline, 1, {
                repeat: -1,
                yoyo: true,
                progress: '+=0.2',
                ease: Quad.easeInOut,
            });
        }
    },

    onTick: function () {
        if (this.particlesEmitter) {
            const now = Date.now();
            const delta = (now - this.elapsedTime) * 0.001;
            this.particlesEmitter.update(delta);
            this.elapsedTime = now;
        }
        // console.log(this.particlesEmitter);
    },

    onFrameUpdate: function (movieclip) {
        if (!movieclip.visible) {
            return;
        }

        const particlesFrames = _.get(this.props.objs, `${movieclip.name}.particles`, null);
        if (particlesFrames === null) {
            return;
        }

        PumpersAnimations.emitParticles(movieclip, this.particlesEmitter, this.sprites.particles, particlesFrames, {
            playAudio: this.props.focus,
        });
    },
});

module.exports = Pumper;



// WEBPACK FOOTER //
// ./js/components/frames/_common/Pumper.jsx